import { type AddEventCallback } from "../types.js";
import { findEventProvider } from "../utils/providers.js";
import { getBody } from "../utils/body.js";

export function patchXMLHTTPRequest(callback: AddEventCallback): () => void {
  if (typeof window.XMLHttpRequest !== 'function') return () => {};
  const origOpen = window.XMLHttpRequest.prototype.open;
  const origSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.open = function (
    method: string,
    url: string | URL
  ) {
    // @ts-expect-error ts stuff
    this.__inspectorMethod = method;
    // @ts-expect-error ts stuff
    this.__inspectorEndpoint = url.toString();
    // @ts-expect-error ts stuff
    return origOpen.apply(this, [].slice.call(arguments));
  };

  window.XMLHttpRequest.prototype.send = function (
    body: string | null | FormData
  ) {
    // @ts-expect-error ts stuff
    if (this.__inspectorEndpoint) {
      // @ts-expect-error ts stuff
      const endpoint = this.__inspectorEndpoint as string;
      const provider = findEventProvider(endpoint);

      if (provider) {
        // @ts-expect-error ts stuff
        const method = ((this.__inspectorMethod as string) ?? '').toUpperCase();
        if (method === 'POST' || method === 'GET') {
          try {
            callback({
              endpoint,
              method: method as 'POST' | 'GET',
              transport: "XHR",
              payload: body && getBody(body as string | FormData),
              provider,
            });
          } catch {
            // never abort client traffic
          }
        }
      }
    }

    // @ts-expect-error ts stuff
    return origSend.apply(this, [].slice.call(arguments));
  };

  return () => {
    window.XMLHttpRequest.prototype.open = origOpen;
    window.XMLHttpRequest.prototype.send = origSend;
  };
}
